// extracted by mini-css-extract-plugin
export default {"skillSection":"SkillItem_skillSection__MYGgH","skillSectionTitle":"SkillItem_skillSectionTitle__IraBV","skillsList":"SkillItem_skillsList__TMWuN"};